import api from "@/api/axios";

// API_URL traegt KEIN /api-Praefix mehr: die Instanz aus @/api/axios
// bringt baseURL="/api" selbst mit. Beides zusammen ergaebe
// /api/api/messages/... -- ein 404, der wie ein fehlender Endpunkt
// aussieht. Uebernommen aus origin/main, das die ganze Datei auf die
// Instanz umgestellt hat.
const API_URL = "/messages";

export const listMessages = (params = {}) => api.get(API_URL, { params });

/**
 * Wer auf Bewertung wartet — die schlanke Auskunft für das Nachladen.
 *
 * ⚠️ Diese Funktion läuft im Takt, dauerhaft und ohne Zutun — deshalb ist
 * der 401-Interceptor der Instanz hier nicht Komfort: ein Tab mit abgelaufener
 * Anmeldung liefe sonst endlos in harte Fehler, statt den Token zu erneuern.
 * Genau das Verhalten zeigt der Chat-Kanal seit jeher
 * (`Global SSE error: Event`).
 *
 * Bis zum Merge mit main war das der Sonderfall: die übrigen Funktionen dieser
 * Datei hingen am nackten `axios`, und dieser Absatz sagte, das werde hier
 * nicht nebenbei mitgefixt. main hat es gefixt — seither läuft die ganze Datei
 * über die Instanz, und der Satz ist nur noch Geschichte.
 *
 * Die Antwort ist bewusst klein (einige hundert Byte): sie führt Zahlen und
 * ID-Listen, keine Nachrichten. `GET /messages` liefert dagegen 2,62 MB für
 * 227 Nachrichten — im Takt geholt wären das rund 31 MB je Minute.
 */
export const getRatingStatus = () => api.get(`${API_URL}/rating-status`);

/**
 * Wer auf Vektorisierung wartet — der Zwilling darüber.
 *
 * ⚠️ Der Takt ist aber ein ANDERER. Der Vektorlauf steht in der Vorgabe auf
 * 604800 s (sieben Tage); ein Poll im 10-Sekunden-Rhythmus fragte tausendfach
 * nach einer Antwort, die sich fast nie ändert. Die Untergrenze im Aufrufer
 * ist deshalb höher als die 5000 der Bewertung.
 */
export const getRagStatus = () => api.get(`${API_URL}/rag-status`);

/**
 * Was die letzte Neubewertung an einer Nachricht geändert hat.
 *
 * Die Daten liegen seit A13 vollständig da — „Rate again" archiviert jede
 * Bewertungszeile, bevor es sie löscht. Gelesen hat die Tabelle bis zum
 * 18.08. niemand; in der Oberfläche war der alte Stand nach dem Klick sofort
 * weg, obwohl er in der Datenbank steht.
 *
 * Die Antwort trägt `staende` (alle Archivvorgänge) und `vergleich` (der
 * jüngste gegen den aktuellen Stand). `vergleich` ist `null`, wenn es keinen
 * Archivstand gibt ODER wenn die Stände sich nicht sicher trennen lassen —
 * dann steht `unklar` am betroffenen Stand.
 */
export const getRatingHistory = (messageId) =>
    api.get(`${API_URL}/${messageId}/rating-history`);

export const approveMessage = (messageId) =>
    api.put(`${API_URL}/${messageId}/approve`);

export const setMessageCriterionRating = (messageId, criterionId, value, comment) =>
    api.put(`${API_URL}/${messageId}/criteria/${criterionId}`, { value, comment });

export const deleteMessage = (messageId) =>
    api.delete(`${API_URL}/${messageId}`);

// ✅ Variante 1: reviewed=false setzen, Ratings bleiben
export const rateAgainMessage = (messageId) =>
    api.post(`${API_URL}/${messageId}/rate-again`);

/**
 * Der Gesprächskontext einer Nachricht — das Fenster, das das bewertende
 * Modell heute in seinen Prompt bekäme.
 *
 * Nur lesen: der Endpunkt schreibt nichts.
 *
 * Die Antwort trennt Rekonstruktion und Beleg. `evidence` fasst das Verhältnis
 * zusammen und ist der einzige Wert, an dem die Oberfläche hängen soll:
 * 'matches' | 'differs' | 'inconsistent' | 'none'. Was die vier bedeuten,
 * steht im Docstring von ConversationContextRead
 * (backend/app/routers/messages.py).
 *
 */
export const getConversationContext = (messageId) =>
    api.get(`${API_URL}/${messageId}/conversation-context`);

/**
 * Das Relevanzurteil ueber den Verlauf dieser Nachricht erheben lassen.
 *
 * Ein zusaetzlicher, separater LLM-Aufruf: er urteilt je Verlaufszeile
 * binaer, ob sie zum selben Kommunikationsstrang gehoert. Der
 * Bewertungsprompt bleibt unberuehrt -- erhoben wird, nicht gefiltert.
 *
 * ACHTUNG: das dauert. Drueben laeuft ein Modell, und ein Kaltstart kostet
 * gemessen rund 68 s; das gui-backend wartet bis zu 300 s. Die Oberflaeche
 * muss das anzeigen, statt so auszusehen, als sei nichts passiert.
 *
 * ACHTUNG, ein Lauf ueber Minuten ist genau der Fall, in dem ein Token
 * dazwischen ablaeuft -- der 401-Interceptor der Instanz faengt das ab.
 */
export const startContextRelevance = (messageId, model) =>
    api.post(`${API_URL}/${messageId}/context-relevance`, null, {
      params: model ? { model } : {},
    });

/**
 * Ein Relevanzurteil von Hand richtigstellen.
 *
 * `value` ist true, false -- oder null, und das heisst "Korrektur
 * zuruecknehmen", NICHT "als irrelevant markieren". Das Modellurteil
 * bleibt in jedem Fall stehen; der Vergleich Modell gegen Mensch ist der
 * Zweck der ganzen Erhebung.
 */
export const setContextRelevance = (messageId, contextMessageId, value) =>
    api.put(
        `${API_URL}/${messageId}/context-relevance/${contextMessageId}`,
        { human_value: value },
    );
